export const TEAMS_STORAGE_PROVIDERS = {
  AllowDropBox: 'Dropbox',
  AllowBox: 'Box',
  AllowGoogleDrive: 'Google Drive',
  AllowShareFile: 'Citrix Files',
  AllowEgnyte: 'Egnyte',
}
export const TEAMS_STORAGE_ALL_OFF = Object.fromEntries(
  Object.keys(TEAMS_STORAGE_PROVIDERS).map((field) => [field, false]),
)
